module.exports = __webpack_public_path__ + "img/bakery_demo-600x450.21d06fbb.jpg";